import { TopCommentSection } from './TopCommentSection'
import { withTopCommentSection } from './withTopCommentSection'

const ConnectedTopCommentSection = withTopCommentSection(TopCommentSection)
export { ConnectedTopCommentSection as TopCommentSection }
